import { IEltTopOpportunity } from 'legacy/lut/classes/models/partner360/ELT/docEltType/IEltTopOpportunity'

export const getDocTopOpportunitiesInitialValues = (): IEltTopOpportunity[] => [
  {
    Deal: 'PC RFP - April 2025 (sample)',
    Size: 0,
  },
  {
    Deal: 'MPS RFP - June 2025 (sample)',
    Size: 0,
  },
  {
    Deal: 'Managed Collaboration - August (sample)',
    Size: 0,
  },
]
